import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup } from '@themesberg/react-bootstrap';

import { StudentTables } from '../components/Student/StudentTables';
import { useDispatch, useSelector } from 'react-redux';
import { studentDataSaga } from 'reduxToolkit/actions';
import { StudentModal } from 'components/Student/StudentModal';
import { studentReducerTypes, storeTypes } from 'types';
import { studentDataUpdateSlice } from 'reduxToolkit/reducers';

const StudentPage = () => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);

    const { studentDataUpdateReset } = studentDataUpdateSlice.actions;
    const [studentEditData, setStudentEditData] = useState<studentReducerTypes.IStudent>();

    const { studentUpdateDataState } = useSelector((state: storeTypes.IStore) => state);
    const { isStudentDataUpdate } = studentUpdateDataState;

    // student data update
    const handleClose = () => setShow(false);

    const studentEdit = (studentData: studentReducerTypes.IStudent) => {
        setStudentEditData(studentData);
        setShow(true);
    };

    const [searchWord, setSearchWord] = useState('');

    const dispatchStudent = useCallback(
        (pageNumber: number, searchingWord: string) => {
            const payload = {
                page: pageNumber,
                search_word: searchingWord,
            };
            dispatch(studentDataSaga(payload));
        },
        [dispatch]
    );

    useEffect(() => {
        if (searchWord !== '') {
            setTimeout(() => {
                dispatchStudent(1, searchWord);
            }, 1000);
        }
    }, [dispatchStudent, searchWord]);

    useEffect(() => {
        dispatchStudent(1, '');
    }, [dispatchStudent]);

    // student Update
    useEffect(() => {
        if (isStudentDataUpdate === true) {
            dispatchStudent(1, '');
            dispatch(studentDataUpdateReset());
            setShow(false);
        }
    }, [studentDataUpdateReset, dispatch, dispatchStudent, isStudentDataUpdate]);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb
                        className="d-none d-md-inline-block"
                        listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}
                    >
                        <Breadcrumb.Item>
                            <FontAwesomeIcon icon={faHome} />
                        </Breadcrumb.Item>

                        <Breadcrumb.Item active>Students</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Students</h4>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <Button onClick={() => setShow(true)} variant="outline-primary" size="sm">
                            Add
                        </Button>
                        {/* <Button variant="outline-primary" size="sm">Export</Button> */}
                    </ButtonGroup>
                </div>
            </div>

            <div className="table-settings mb-4">
                <Row className="justify-content-between align-items-center">
                    <Col xs={8} md={6} lg={3} xl={4}>
                        <InputGroup>
                            <InputGroup.Text>
                                <FontAwesomeIcon icon={faSearch} />
                            </InputGroup.Text>
                            <Form.Control
                                value={searchWord}
                                onChange={(e) => setSearchWord(e.target.value)}
                                type="text"
                                placeholder="Search"
                            />
                        </InputGroup>
                    </Col>
                </Row>
            </div>

            <StudentTables studentEdit={studentEdit} dispatchStudent={dispatchStudent} />

            {show && <StudentModal studentEditData={studentEditData} handleClose={handleClose} />}
        </>
    );
};

export default StudentPage;
